import { CalendarDate } from '@internationalized/date';
import { parse, format, Locale } from 'date-fns';

export const formatTimeTo12Hour = (
  timeString: string,
  options: { lowerCase?: boolean; noSpacing?: boolean } = {},
): string => {
  try {
    const timeSegmentCount = timeString.split(':').length;
    const date = parse(
      timeSegmentCount === 3 ? timeString : `${timeString}:00`,
      'HH:mm:ss',
      new Date(),
    );

    let formattedTime = format(date, 'h:mm a');

    if (options.noSpacing) {
      formattedTime = formattedTime.replace(' ', '');
    }

    if (options.lowerCase) {
      formattedTime = formattedTime.toLowerCase();
    }

    return formattedTime;
  } catch {
    return 'Invalid Date';
  }
};

export const formatDateToFullDateString = ({
  dateString,
  locale,
  parseFormat = 'yyyy-MM-dd',
  dateFormat = 'EEEE, MMMM d, yyyy',
}: {
  dateString: string;
  locale?: Locale;
  parseFormat?: string;
  dateFormat?: string;
}): string => {
  try {
    const date = parse(dateString, parseFormat || 'yyyy-MM-dd', new Date(), {
      locale: locale ?? undefined,
    });

    return format(date, dateFormat || 'EEEE, MMMM d, yyyy', {
      locale: locale ?? undefined,
    });
  } catch {
    return 'Invalid Date';
  }
};

export const formatDateString = (
  dateString: string,
  pattern: string,
): string => {
  try {
    const date = parse(dateString, 'yyyy-MM-dd', new Date());

    return format(date, pattern);
  } catch {
    return 'Invalid Date';
  }
};

export const parseCalendarDate = (date?: string): CalendarDate | undefined => {
  if (!date) {
    return undefined;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date.split('-').map(Number);
    return new CalendarDate(year, month, day);
  }
  throw new Error('Invalid date format');
};

export const tzFreeDate = (dateStr?: string): Date => {
  const date = dateStr ? new Date(dateStr) : new Date();
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};
